// Globals
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

// Models
import { ConversationMessageRole, IConversationMessage } from '@/models/conversation.model';
import { ITheme } from '@/models/theme.model';

// Components
import { Spinner } from '@/ui';
import { StyledCard, StyledCardHeader, StyledCardTitle } from '../Styled';
import { StyledLoaderWrapper, StyledMessage, StyledTranscriptBody } from './ConversationTranscriptCardStyles';

// Helpers
import { renderMarkdown } from '@/utils';

type TConversationTranscriptCardProps = {
  messages: IConversationMessage[];
  userMessageTheme?: Pick<ITheme, 'primaryColor' | 'colorOnPrimary'> | null;
  isLoading?: boolean;
};

const ConversationTranscriptCard: FC<TConversationTranscriptCardProps> = ({
  messages,
  userMessageTheme,
  isLoading,
}) => {
  const { t } = useTranslation();

  return (
    <StyledCard>
      <StyledCardHeader>
        <StyledCardTitle>{t('conversation_transcript_title')}</StyledCardTitle>
      </StyledCardHeader>
      {isLoading ? (
        <StyledLoaderWrapper>
          <Spinner />
        </StyledLoaderWrapper>
      ) : (
        <StyledTranscriptBody>
          {messages.map((message) => (
            <StyledMessage
              key={message.messageId}
              $isUser={message.role === ConversationMessageRole.USER}
              $background={userMessageTheme?.primaryColor}
              $color={userMessageTheme?.colorOnPrimary}
              dangerouslySetInnerHTML={{ __html: renderMarkdown(message.text) }}
            />
          ))}
        </StyledTranscriptBody>
      )}
    </StyledCard>
  );
};

export default ConversationTranscriptCard;
